var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 58,
    viewBox: "0 0 44 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 45H31.988V46.632H27.908V48.456H30.884V50.088L27.908 50.1V52.3H32.132V53.932H26V45Z",
    fill: "#1B648D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.908 48.456H13.8L13.812 50.088L10.912 50.1V53.928H9V45H14.784V46.632H10.908V48.456Z",
    fill: "#1B648D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45H20.907V52.3H24.675V53.932H19V45Z",
    fill: "#1B648D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.84 14.73C43.82 14.71 43.8 14.68 43.78 14.66C43.7596 14.6309 43.7361 14.6041 43.71 14.58L29.42 0.29C29.4 0.27 29.37 0.25 29.35 0.23C29.33 0.21 29.29 0.18 29.27 0.16L29.12 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V54C0 55.0609 0.421427 56.0783 1.17157 56.8284C1.92172 57.5786 2.93913 58 4 58H40C41.0609 58 42.0783 57.5786 42.8284 56.8284C43.5786 56.0783 44 55.0609 44 54V14.88L43.84 14.73ZM42 54C41.9984 54.5299 41.7872 55.0377 41.4125 55.4125C41.0377 55.7872 40.5299 55.9984 40 56H4C3.47005 55.9984 2.96227 55.7872 2.58753 55.4125C2.2128 55.0377 2.00158 54.5299 2 54V38.46H15.73L18.43 41.55C18.5229 41.6576 18.6381 41.7438 18.7676 41.8025C18.8971 41.8612 19.0378 41.8911 19.18 41.89H42V54ZM6 25.35V23.35H38V25.35H6ZM38 27.75V29.75H20.29V27.75H38ZM38 20.96H6V18.96H38V20.96ZM6 16.56V14.56H23.71V16.56H6ZM31.71 14.29C31.1801 14.2884 30.6723 14.0772 30.2975 13.7025C29.9228 13.3277 29.7116 12.8199 29.71 12.29V3.41L40.59 14.29H31.71Z",
    fill: "#1B648D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45H17.908V53.928H16V45Z",
    fill: "#1B648D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFileIcon);
export default __webpack_public_path__ + "static/media/defaultFileIcon.01cf6e84ea94b44715b5543ed812c36b.svg";
export { ForwardRef as ReactComponent };